export const isHtml = (str: string): boolean => {
  if (typeof str !== 'string') return false;

  str = str.trim();

  const htmlRegex = /<\/?[a-z][\s\S]*>/i;

  return htmlRegex.test(str);
};

/**
 * Converts any string to camel case.
 */
export const toCamelCase = (key: string): string => {
  return key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_\-\s]+/g, ' ')
    .toLowerCase()
    .replace(/ (.)/g, (_, group1) => group1.toUpperCase());
};

/**
 * Recursively converts keys of all nested objects/arrays to camel case.
 * @param input The input object or array to convert.
 * @returns The converted object or array with camel case keys.
 */
export const toNestedCamelCaseKeys = <TInput>(input: TInput): TInput => {
  if (Array.isArray(input)) {
    return input.map(toNestedCamelCaseKeys) as TInput;
  } else if (input !== null && typeof input === 'object') {
    return Object.entries(input).reduce((acc, [key, value]) => {
      const newKey = toCamelCase(key);
      acc[newKey as never] = toNestedCamelCaseKeys(value);

      return acc;
    }, {} as never) as TInput;
  }
  return input;
};
